import { IAlert } from '@store/types';
import { EventEmitter } from 'eventemitter3';

export const emitter = new EventEmitter();

export enum EmitterEvent {
  Alert = 'Alert',
  CatalogProductAdd = 'CatalogProductAdd',
  BasketReload = 'BasketReload',
}

export const emit = {
  alert: (alert: IAlert) => emitter.emit(EmitterEvent.Alert, alert),
  basket: {
    reload: (widgetUrl: string) => emitter.emit(EmitterEvent.BasketReload, widgetUrl),
  },
};
